<div class="preview-wrap">
  <table class="preview-table">
    <thead>
      <tr>
        <th *ngFor="let col of cols">{{ col }}</th>
      </tr>
    </thead>
    <tbody>
      <tr *ngFor="let row of previewRows">
        <td *ngFor="let col of cols; let i = index">{{ cellValue(row, i) }}</td>
      </tr>
    </tbody>
  </table>
</div>
